import { ResourceEdit, TextField, Typography } from "@cakemail-org/ui-components-v2"
import { useTranslation } from "react-i18next"
import { Stack } from "@mui/material"
import { ChangeEvent, useState } from "react"
import { TPageSeoEdit } from "./types"
import "./styles.scss"
import { setDataInPath } from "../../../../utils/data"

export function PageSeoEdit({ page, savePage }: TPageSeoEdit) {
    const seoData = page?.seo || {}

    const { t } = useTranslation()

    function handleSeoFieldChangeTimeout(event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
        const { name, value } = event.target

        const dataToUpdate = setDataInPath({ name, value, data: page.seo, merge: true })

        savePage({
            dataToUpdate,
            render: false
        })
    }

    const hasSeoData = seoData.title || seoData.description

    const support = hasSeoData && <Stack className="google-preview">
        <Typography variant="body2" className="google-preview-title">
            {seoData.title}
        </Typography>
        <Typography variant="body1" className="google-preview-url">
            {page.published_url}
        </Typography>
        <Typography variant="body1" className="google-preview-description">
            {seoData.description}
        </Typography>
    </ Stack>

    return (
        <ResourceEdit
            className="pageSeoEditResource"
            editable
            status={
                hasSeoData ? "valid" : "empty"
            }
            title={t("pages-details-seo-title")}
            desc={t("pages-details-seo-desc")}
            support={support}
            editableContent={<Stack gap={6}>
                <Stack gap={6}>
                    <TextField
                        name="seo.title"
                        label={t("general-title")}
                        placeholder={t("pages-details-seo-title-placeholder")}
                        defaultValue={seoData.title || ""}
                        timeout={{
                            callback: handleSeoFieldChangeTimeout
                        }}
                    />
                    <TextField
                        name="seo.description"
                        label={t("general-description")}
                        placeholder={t("pages-details-seo-description-placeholder")}
                        defaultValue={seoData.description || ""}
                        multiline
                        rows={3}
                        timeout={{
                            callback: handleSeoFieldChangeTimeout
                        }}
                    />
                </Stack>
                {support}
            </Stack>
            }
        />
    )
}

